import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AR_TABLE_PREFERENCES } from '../constants';
import {
  AccountDetails,
  PatientBillingSummaryResp,
  PaymentPlan,
  PreviewPaymentPlan,
  RoleMasterData,
} from '../models';
import { LocalStorageService } from './local-storage.service';
import { SharedService } from './shared.service';
import { UserService } from './user.service';
import { UtilService } from './util.service';
import { UserRoleService } from './user-role.service';
import { SignalRService } from './signalr.service';
import { BehaviorSubject, finalize } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AccountStatusService } from './account-status.service';
import { ACCOUNTSTATUS } from '../constants/practice.constant';
import { RoleMasterEnum } from '../constants/user-roles.constant';
declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  practiceId = 0;
  signinPracticeId: any = 0;
  menuList: any[] = [];
  userRoleDetails: RoleMasterData;
  menuListByCustomerSubscription: any;
  private menuListSubject = new BehaviorSubject<any[]>([]);
  menuList$ = this.menuListSubject.asObservable();
  isPracticeAdmin =false;
  isSuspended =false;
  isAutoSigningIn = false;
  isAccept = false;
  isCallSharedService = false;
  constructor(
    private jwtHelper: JwtHelperService,
    private router: Router,
    private _sharedService: SharedService,
    private _localStorageService: LocalStorageService,
    private signalRService: SignalRService,
    private _roleMasterService: UserRoleService,
    private _utilService: UtilService,
    private _userService: UserService,
    private dialog: MatDialog,
    private _accountService:AccountStatusService
    //private cdr: ChangeDetectorRef,
  ) {}

  isAuthenticated(): boolean {
    const token = localStorage.getItem('authToken');
    return !this.jwtHelper.isTokenExpired(token);
  }

  logout() {
    const loggedInUser = localStorage.getItem('loggedInUser');
    if(loggedInUser){
      this._userService.signOut().subscribe();
    }
    this._accountService.stopChecking();
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('authToken');
    this.signalRService?.stopConnection();
    this.router.navigate(['/login']).then(() => {
      this.resetSharedService();
    });
  }

  resetSharedService() {
    this._sharedService.setAccountDetails(new AccountDetails());
    this._sharedService.setBillingPaymentsData(new PatientBillingSummaryResp());
    this._sharedService.setFormSubmitted(false);
    this._sharedService.setNote('');
    this._sharedService.setNoteSubject('');
    this._sharedService.setPatientId(0);
    this._sharedService.setPaymentPlanValues({
      paymentPlanAmt: 0,
      todayPaymentAmt: 0,
      remainingPaymentPlanAmt: 0,
      remainingPatientPortion: 0,
    });
    this._sharedService.setPaymentType('');
    this._sharedService.setPracticeId(0);
    this._sharedService.setPreviewPaymentPlanValues(new PreviewPaymentPlan());
    this._sharedService.setProviderId(0);
    this._sharedService.setSelectedPaymentPlanEmisValues([]);
    this._sharedService.setSelectedPaymentPlanValues(new PaymentPlan());
    this._sharedService.setARDetailsTableName(AR_TABLE_PREFERENCES.AR_BY_DOS);
    this._sharedService.setTablePreferenceName('');
    this._sharedService.setUserId(0);
    this._sharedService.setIsFormDirty(false);
    this._localStorageService.setData('menuListByCustomerSubscription', []);
    localStorage.removeItem('isApplyPaymentPromotion');
    localStorage.removeItem('isAllowPaymentPlanAdjustment');
    localStorage.removeItem('isCheckedARByDOS');
    localStorage.removeItem('isCheckedARByPayor');
    localStorage.removeItem('isCheckedARByPatient');
    localStorage.removeItem('isCheckedARTargetList');
    localStorage.removeItem('isCheckedARCreateTargetList');
    localStorage.removeItem('isCheckedAREditTargetList');
    localStorage.removeItem('isCheckedARCreateCampaign');
    localStorage.removeItem('isCheckedAREditCampaign');
    localStorage.removeItem('isCheckedARSummary');
    localStorage.removeItem('isCheckedTodaysPatients');
    localStorage.removeItem('isCheckedAllPatients');
    localStorage.removeItem('isCheckedAssessment');
    localStorage.removeItem('isCheckedCreateAssessment');
    localStorage.removeItem('isCheckedEditAssessment');
    localStorage.removeItem('isCheckedDeleteAssessment');
    localStorage.removeItem('isCheckedCustomForm');
    localStorage.removeItem('isCheckedCreateCustomForm');
    localStorage.removeItem('isCheckedEditCustomForm');
    localStorage.removeItem('isCheckedDeleteCustomForm');
    localStorage.removeItem('isCheckedAccountDetails');
    localStorage.removeItem('isCheckedAgreementCC');
    localStorage.removeItem('isCheckedPMSConfiguration');
    localStorage.removeItem('isCheckedProcessorSetting');
    localStorage.removeItem('isCheckedTerminalSetup');
    localStorage.removeItem('isCheckedUser');
    localStorage.removeItem('isCheckedUserRole');
    localStorage.removeItem('isCheckedCarrierMaster');
    localStorage.removeItem('isCheckedCarrierPlanMaster');
    localStorage.removeItem('isCheckedCarrierMapping');
    localStorage.removeItem('isCheckedSubscriptions');
    localStorage.removeItem('isCheckedEditCustomer');
    localStorage.removeItem('isCheckedCreatePractice');
    localStorage.removeItem('isCheckedEditPractice');
    localStorage.removeItem('isCheckedAddSubscription');
    localStorage.removeItem('isCheckedAddPaymentMethod');
    localStorage.removeItem('isCheckedInviteUser');
    localStorage.removeItem('isCheckedEditPMSConfiguration');
    localStorage.removeItem('isCheckedCreateTerminalSetup');
    localStorage.removeItem('isCheckedEditTerminalSetup');
    localStorage.removeItem('isCheckedCreateProcessorSetting');
    localStorage.removeItem('isCheckedEditProcessorSetting');
    localStorage.removeItem('isCheckedCreateUser');
    localStorage.removeItem('isCheckedEditUser');
    localStorage.removeItem('isCheckedCreateInviteUser');
    localStorage.removeItem('isCheckedEditInviteUser');
    localStorage.removeItem('isCheckedCreateUserRole');
    localStorage.removeItem('isCheckedEditUserRole');
    localStorage.removeItem('isCheckedCreatePaymentPlanTemplates');
    localStorage.removeItem('isCheckedEditPaymentPlanTemplates');
    localStorage.removeItem('isCheckedCreateARAutomationTemplates');
    localStorage.removeItem('isCheckedEditARAutomationTemplates');
    localStorage.removeItem('lastAccountStatus');
    localStorage.removeItem('isCheckedPaymentMethodOnFile');
    localStorage.removeItem('isCheckedScheduledJobs');
    localStorage.removeItem('isCheckedDeletePaymentMethodOnFile');
    localStorage.removeItem('isCheckedCreatePaymentMethodOnFile');
  }



  /// Auto Logout and Login functions

  autoLogoutLogin() {
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('authToken');
    this.resetSharedService();
  }

  // resetSharedService() {
  //   this._sharedService.setAccountDetails(new AccountDetails());
  //   this._sharedService.setBillingPaymentsData(new PatientBillingSummaryResp());
  //   this._sharedService.setFormSubmitted(false);
  //   this._sharedService.setNote('');
  //   this._sharedService.setNoteSubject('');
  //   this._sharedService.setPatientId(0);
  //   this._sharedService.setPaymentPlanValues({
  //     paymentPlanAmt: 0,
  //     todayPaymentAmt: 0,
  //     remainingPaymentPlanAmt: 0,
  //     remainingPatientPortion: 0,
  //   });
  //   this._sharedService.setPaymentType('');
  //   this._sharedService.setPracticeId(0);
  //   this._sharedService.setPreviewPaymentPlanValues(new PreviewPaymentPlan());
  //   this._sharedService.setProviderId(0);
  //   this._sharedService.setSelectedPaymentPlanEmisValues([]);
  //   this._sharedService.setSelectedPaymentPlanValues(new PaymentPlan());
  //   this._sharedService.setARDetailsTableName(AR_TABLE_PREFERENCES.AR_BY_DOS);
  //   this._sharedService.setTablePreferenceName('');
  //   this._sharedService.setUserId(0);
  //   this._localStorageService.setData('menuListByCustomerSubscription', []);
  //   localStorage.removeItem('isApplyPaymentPromotion');
  //   localStorage.removeItem('isAllowPaymentPlanAdjustment');
  //   localStorage.removeItem('isCheckedARByDOS');
  //   localStorage.removeItem('isCheckedARByPayor');
  //   localStorage.removeItem('isCheckedARByPatient');
  //   localStorage.removeItem('isCheckedARTargetList');
  //   localStorage.removeItem('isCheckedARCreateTargetList');
  //   localStorage.removeItem('isCheckedAREditTargetList');
  //   localStorage.removeItem('isCheckedARCreateCampaign');
  //   localStorage.removeItem('isCheckedAREditCampaign');
  //   localStorage.removeItem('isCheckedARSummary');
  //   localStorage.removeItem('isCheckedTodaysPatients');
  //   localStorage.removeItem('isCheckedAllPatients');
  //   localStorage.removeItem('isCheckedAssessment');
  //   localStorage.removeItem('isCheckedCreateAssessment');
  //   localStorage.removeItem('isCheckedEditAssessment');
  //   localStorage.removeItem('isCheckedDeleteAssessment');
  //   localStorage.removeItem('isCheckedCustomForm');
  //   localStorage.removeItem('isCheckedCreateCustomForm');
  //   localStorage.removeItem('isCheckedEditCustomForm');
  //   localStorage.removeItem('isCheckedDeleteCustomForm');
  //   localStorage.removeItem('isCheckedAccountDetails');
  //   localStorage.removeItem('isCheckedAgreementCC');
  //   localStorage.removeItem('isCheckedPMSConfiguration');
  //   localStorage.removeItem('isCheckedProcessorSetting');
  //   localStorage.removeItem('isCheckedTerminalSetup');
  //   localStorage.removeItem('isCheckedUser');
  //   localStorage.removeItem('isCheckedUserRole');
  //   localStorage.removeItem('isCheckedCarrierMaster');
  //   localStorage.removeItem('isCheckedCarrierPlanMaster');
  //   localStorage.removeItem('isCheckedCarrierMapping');
  //   localStorage.removeItem('isCheckedSubscriptions');
  //   localStorage.removeItem('isCheckedEditCustomer');
  //   localStorage.removeItem('isCheckedCreatePractice');
  //   localStorage.removeItem('isCheckedEditPractice');
  //   localStorage.removeItem('isCheckedAddSubscription');
  //   localStorage.removeItem('isCheckedAddPaymentMethod');
  //   localStorage.removeItem('isCheckedInviteUser');
  //   localStorage.removeItem('isCheckedEditPMSConfiguration');
  //   localStorage.removeItem('isCheckedCreateTerminalSetup');
  //   localStorage.removeItem('isCheckedEditTerminalSetup');
  //   localStorage.removeItem('isCheckedCreateProcessorSetting');
  //   localStorage.removeItem('isCheckedEditProcessorSetting');
  //   localStorage.removeItem('isCheckedCreateUser');
  //   localStorage.removeItem('isCheckedEditUser');
  //   localStorage.removeItem('isCheckedCreateInviteUser');
  //   localStorage.removeItem('isCheckedEditInviteUser');
  //   localStorage.removeItem('isCheckedCreateUserRole');
  //   localStorage.removeItem('isCheckedEditUserRole');
  //   localStorage.removeItem('isCheckedCreatePaymentPlanTemplates');
  //   localStorage.removeItem('isCheckedEditPaymentPlanTemplates');
  //   localStorage.removeItem('isCheckedCreateARAutomationTemplates');
  //   localStorage.removeItem('isCheckedEditARAutomationTemplates');
  // }

  submitForAutoLoginLogout(id?:number,onAccept:boolean=false){ 
    this.isCallSharedService = true;
    if(!id){
      this.isAutoSigningIn = true;
    }
    if(onAccept){
      this.isAccept = true;
    }
    const currentUrl = this.router.url;
    if (!id && currentUrl !== '/practice/all-practice/agreement-cc' && currentUrl !== '/practice/all-practice/account-details') {
      this.router.navigate(['/practice/all-practice/account-details']);
    }
    this.isSuspended = false;
    this.isPracticeAdmin = false;
    this._userService
      .autoSignIn(id)
      .pipe(
        finalize(() => {
          //this.cdr.detectChanges();
        })
      )
      .subscribe((responseMain) => {
        this.autoLogoutLogin();
        if (responseMain.isSuccess) {
          localStorage.setItem(
            'loggedInUser',
            JSON.stringify(responseMain.data)
          );
          localStorage.setItem('authToken', responseMain.data?.token || '');         
          const userToken = localStorage.getItem('authToken');
          const loggedInUser = this._localStorageService.getLoggedInUser();
          if (userToken && loggedInUser) {
            this._userService.getAccountDetails().subscribe((response) => {
              if (response.isSuccess) {               
                if(response.data?.practiceInfo?.status){ 
                  localStorage.setItem("lastAccountStatus", response.data?.practiceInfo?.status.toString());
                  if(response.data?.practiceInfo?.status == ACCOUNTSTATUS.PracticeSuspended){
                    this.isSuspended = true;
                    if(loggedInUser?.roleName == RoleMasterEnum.PracticeAdmin){
                      this.isPracticeAdmin = true;
                    } 
                  }                  
                }
                   this.practiceId = response.data?.practiceInfo?.id || 0;
                    this._sharedService.setPracticeId(this.practiceId);

                this.getRoleMaster(
                  localStorage.getItem('authToken') || '',
                  responseMain.message,
                  this.practiceId
                );
                // this.practiceId = response.data?.practiceInfo?.id || 0;              
                // this._sharedService.setPracticeId(this.practiceId);
              }
            });
          }
        }
      });
  }

  getRoleMaster(userToken: string, message: string, practiceId: number) {
    const loggedInUser = this._localStorageService.getLoggedInUser();

    if (loggedInUser.roleId) {       
      this.getRoleMasterByMember(message);
    }
    this.signalRService.startConnection(userToken, Number(practiceId || 0));
  }

  getRoleMasterByMember(message: string) {
    this._roleMasterService
      .GetRoleMasterByMember()
      .pipe(
        finalize(() => {
          // this.isLoadingSettings = false;
        })
      )
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.userRoleDetails = res.data;
          this.getPracticeConfigurationByModule(message);
        }
      });
  }

  getPracticeConfigurationByModule(message: string) {
    if (!this.practiceId) {
      return;
    }
    const reqBody = {
      practiceId: this.practiceId,
    };
    this.getDefaultMenuList(reqBody, message);
  }

  getDefaultMenuList(reqBody: any, message: string) {
    this._roleMasterService
      .GetMenuListByCustomerSubscription(reqBody)
      .pipe(
        finalize(() => {
          //this.cdr.detectChanges();
        })
      )
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.menuList = res.data;
          this.groupMenusByModule(message);
        }
      });
  }

  groupMenusByModule(message: string) {
    let menuData = this.menuList.map((data: any) => {
      return {
        ...data,
        checked:
          this.userRoleDetails?.roleDetails &&
            this.userRoleDetails?.roleDetails?.find(
              (item: any) => data.menuId == item.menuId
            )
            ? true
            : false,
        menuName: data.menuName,
        displayText:
          data.type == 1
            ? data.displayText
            : data.type == 2
              ? data.displayText
              : data.type == 3
                ? data.displayText
                : data.displayText,
      };
    });

    const menuMap = new Map<number, any>();

    menuData.forEach((menu) => {
      if (!menuMap.has(menu.moduleId)) {
        menuMap.set(menu.moduleId, {
          moduleId: menu.moduleId,
          moduleName: menu.moduleName,
          menus: [],
        });
      }
      menuMap.get(menu.moduleId).menus.push(menu);
    });
    this.menuListByCustomerSubscription = Array.from(menuMap.values()).map(
      (module) => {
        return {
          ...module,
          menus: this._utilService.buildHierarchy(module.menus),
        };
      }
    );
    this.menuListSubject.next(this.menuListByCustomerSubscription);
    // this.isSubmitted = false;
    // this.isLoadingSettings = false;
    // this._snackBarService.openSnackBar(message || RESPONSE[200], 'Success');
    if (this.menuListByCustomerSubscription?.length) {
      // const tabSettings = this.menuListByCustomerSubscription?.find(
      //   (c: any) => c.menus?.[0]?.checked
      // );
      const tabSettings = this.isAccept
          ? (
              this.menuListByCustomerSubscription?.find(
                (c: any) =>
                  c.moduleName === 'Practice' &&
                  c.menus?.[0]?.checked
              ) ||
              this.menuListByCustomerSubscription?.find(
                (c: any) => c.menus?.[0]?.checked
              )
            )
          : this.menuListByCustomerSubscription?.find(
              (c: any) => c.menus?.[0]?.checked
            );
      if (!tabSettings) {
        this.router.navigate(['/other/forbidden']);
      }
        switch (tabSettings?.moduleName) {
          case 'Payments': {
            this.router.navigateByUrl('/payments/patients', { replaceUrl: true }).then(() => {
              window.location.href = '/payments/patients';
            });
            break;
          }
          case 'Payment Plan': {
            this.router.navigateByUrl('/payment-plan/payment-plan', { replaceUrl: true }).then(() => {
              window.location.href = '/payment-plan/payment-plan';
            });
            break;
          }
          case 'A/R Automation': {
            this.router.navigateByUrl('/ar-automation/ar-details', { replaceUrl: true }).then(() => {
              window.location.href = '/ar-automation/ar-details';
            });
            break;
          }
          case 'Practice Analytics': {
            this.router.navigateByUrl('/practice-analytics/kpi-dashboard/financial-overview', { replaceUrl: true }).then(() => {
              window.location.href = '/practice-analytics/kpi-dashboard/financial-overview';
            });
            break;
          }
          // case 'Practice Assessment': {
          //   this.router.navigate([
          //     '/practice-assessment/practice-assessment/tabs/assessment',
          //   ]);
          //   break;
          // }
          case 'Practice': {      
            if(this.isAccept){
              this.router.navigateByUrl('/practice/all-practice/agreement-cc', { replaceUrl: true }).then(() => {
                window.location.href = '/practice/all-practice/agreement-cc';
              });
            }else{
                this.router.navigateByUrl('/practice/all-practice/account-details', { replaceUrl: true }).then(() => {
                window.location.href = '/practice/all-practice/account-details';
              });
            }          
            break;
          }
        }
      this.setActionsConfig();
    }else{
      if(this.isSuspended && !this.isPracticeAdmin){
        this.router.navigate(['/other/suspended-account']);
      }
    }
  }


  setActionsConfig() {
    const actionSettingsARDetails = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'A/R Automation')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'A/R Details'
      )?.children;
    const isCheckedCreateARTargetList =
      actionSettingsARDetails?.find(
        (x: any) => x.menuName === 'Create A/R Target Lists'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateARTargetList',
      isCheckedCreateARTargetList
    );
    const isCheckedEditARTargetList =
      actionSettingsARDetails?.find(
        (x: any) => x.menuName === 'Edit A/R Target Lists'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditARTargetList',
      isCheckedEditARTargetList
    );
    const tabSettingsCampaign = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'A/R Automation')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Campaign'
      )?.children;

    const isCheckedCreateCampaign =
      tabSettingsCampaign?.find(
        (x: any) => x.menuName === 'Create A/R Automation Campaign'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateCampaign',
      isCheckedCreateCampaign
    );
    const isCheckedEditCampaign =
      tabSettingsCampaign?.find(
        (x: any) => x.menuName === 'Edit A/R Automation Campaign'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditCampaign',
      isCheckedEditCampaign
    );
    const tabSettingsPracticeAssessment = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'Practice Assessment')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Practice Assessment'
      )?.children;
    const isCheckedCreateAssessment =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Create Assessment'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateAssessment',
      isCheckedCreateAssessment
    );
    const isCheckedEditAssessment =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Edit Assessment'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditAssessment',
      isCheckedEditAssessment
    );
    const isCheckedDeleteAssessment =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Delete Assessment'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedDeleteAssessment',
      isCheckedDeleteAssessment
    );
    const isCheckedCreateCustomForm =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Create Custom Form'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateCustomForm',
      isCheckedCreateCustomForm
    );
    const isCheckedEditCustomForm =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Edit Custom Form'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditCustomForm',
      isCheckedEditCustomForm
    );
    const isCheckedDeleteCustomForm =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Delete Custom Form'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedDeleteCustomForm',
      isCheckedDeleteCustomForm
    );
    const tabSettingsPracticeDetails = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'Practice')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Practice Details'
      )?.children;
    const isCheckedEditCustomer =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit Customer'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditCustomer',
      isCheckedEditCustomer
    );
    const isCheckedCreatePractice =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Create Practice'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreatePractice',
      isCheckedCreatePractice
    );
    const isCheckedEditPractice =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit Practice'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditPractice',
      isCheckedEditPractice
    );
    const isCheckedAddSubscription =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Add Subscription in Agreement & CC'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedAddSubscription',
      isCheckedAddSubscription
    );
    const isCheckedAddPaymentMethod =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Add Payment Method'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedAddPaymentMethod',
      isCheckedAddPaymentMethod
    );
    const isCheckedInviteUser =
      tabSettingsPracticeDetails?.find((x: any) => x.menuName === 'Invite User')
        ?.checked || false;
    this._localStorageService.setData(
      'isCheckedInviteUser',
      isCheckedInviteUser
    );
    const isCheckedEditPMSConfiguration =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit PMS Configuration'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditPMSConfiguration',
      isCheckedEditPMSConfiguration
    );
    const isCheckedCreateTerminalSetup =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Create Terminal Setup'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateTerminalSetup',
      isCheckedCreateTerminalSetup
    );
    const isCheckedEditTerminalSetup =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit Terminal Setup'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditTerminalSetup',
      isCheckedEditTerminalSetup
    );

    const isCheckedCreateProcessorSetting =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Create Processor Setting'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateProcessorSetting',
      isCheckedCreateProcessorSetting
    );
    const isCheckedEditProcessorSetting =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit Processor Setting'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditProcessorSetting',
      isCheckedEditProcessorSetting
    );
    const isCheckedCreateUser =
      tabSettingsPracticeDetails?.find((x: any) => x.menuName === 'Create User')
        ?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateUser',
      isCheckedCreateUser
    );
    const isCheckedEditUser =
      tabSettingsPracticeDetails?.find((x: any) => x.menuName === 'Edit User')
        ?.checked || false;
    this._localStorageService.setData('isCheckedEditUser', isCheckedEditUser);
    const isCheckedCreateInviteUser =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Create Invite User'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateInviteUser',
      isCheckedCreateInviteUser
    );
    const isCheckedEditInviteUser =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit Invite User'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditInviteUser',
      isCheckedEditInviteUser
    );
    const isCheckedCreateUserRole =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Create User Role'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateUserRole',
      isCheckedCreateUserRole
    );
    const isCheckedEditUserRole =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Edit User Role'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditUserRole',
      isCheckedEditUserRole
    );
    const tabSettingsTemplates = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'Practice')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Practice Templates'
      )?.children;
    const isCheckedCreatePaymentPlanTemplates =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'Create Payment Plan Templates'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreatePaymentPlanTemplates',
      isCheckedCreatePaymentPlanTemplates
    );

    const isCheckedEditPaymentPlanTemplates =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'Edit Payment Plan Templates'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditPaymentPlanTemplates',
      isCheckedEditPaymentPlanTemplates
    );
    const isCheckedCreateARAutomationTemplates =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'Create A/R Automation Templates'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedCreateARAutomationTemplates',
      isCheckedCreateARAutomationTemplates
    );

    const isCheckedEditARAutomationTemplates =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'Edit A/R Automation Templates'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedEditARAutomationTemplates',
      isCheckedEditARAutomationTemplates
    );

    const tabSettingsPayments = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'Payments')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Patients'
      )?.children;
    const isCheckedTodaysPatients =
      tabSettingsPayments?.find((x: any) => x.menuName === 'Today’s Patients')
        ?.checked || false;
    const isCheckedAllPatients =
      tabSettingsPayments?.find((x: any) => x.menuName === 'All Patients')
        ?.checked || false;
    this._localStorageService.setData(
      'isCheckedTodaysPatients',
      isCheckedTodaysPatients
    );
    this._localStorageService.setData(
      'isCheckedAllPatients',
      isCheckedAllPatients
    );
    const tabSettingsARAutomationDashboard = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'A/R Automation')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'A/R Automation Dashboard'
      )?.children;
    const isCheckedARSummary =
      tabSettingsARAutomationDashboard?.find(
        (x: any) => x.menuName === 'A/R Summary Dashboard'
      )?.checked || false;
    this._localStorageService.setData('isCheckedARSummary', isCheckedARSummary);
    const isCheckedARByDOS =
      actionSettingsARDetails?.find((x: any) => x.menuName === 'A/R By DoS')
        ?.checked || false;
    this._localStorageService.setData('isCheckedARByDOS', isCheckedARByDOS);
    const isCheckedARByPayor =
      actionSettingsARDetails?.find((x: any) => x.menuName === 'A/R By Payor')
        ?.checked || false;
    this._localStorageService.setData('isCheckedARByPayor', isCheckedARByPayor);
    const isCheckedARByPatient =
      actionSettingsARDetails?.find((x: any) => x.menuName === 'A/R By Patient')
        ?.checked || false;
    this._localStorageService.setData(
      'isCheckedARByPatient',
      isCheckedARByPatient
    );
    const isCheckedARTargetList =
      actionSettingsARDetails?.find(
        (x: any) => x.menuName === 'A/R Target Lists'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedARTargetList',
      isCheckedARTargetList
    );
    const isCheckedAssessment =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Assessment'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedAssessment',
      isCheckedAssessment
    );
    const isCheckedCustomForm =
      tabSettingsPracticeAssessment?.find(
        (x: any) => x.menuName === 'Custom Form'
      )?.checked || false;

    this._localStorageService.setData(
      'isCheckedCustomForm',
      isCheckedCustomForm
    );
    const isCheckedAccountDetails =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Account Details'
      )?.checked || false;
    const isCheckedAgreementCC =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Agreement & CC'
      )?.checked || false;
    const isCheckedPMSConfiguration =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'PMS Configuration'
      )?.checked || false;
    const isCheckedProcessorSetting =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Processor Setting'
      )?.checked || false;
    const isCheckedTerminalSetup =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Terminal Setup'
      )?.checked || false;
    const isCheckedScheduledJobs =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Scheduled Jobs'
      )?.checked || false;
    const isCheckedPaymentMethodOnFile =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Payment Method on File'
      )?.checked || false;
    const isCheckedUser =
      tabSettingsPracticeDetails?.find((x: any) => x.menuName === 'User')
        ?.checked || false;
    const isCheckedUserRole =
      tabSettingsPracticeDetails?.find((x: any) => x.menuName === 'User Role')
        ?.checked || false;
    const isCheckedCarrierMaster =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Carrier Master'
      )?.checked || false;
    const isCheckedCarrierPlanMaster =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Carrier Plan Master'
      )?.checked || false;
    const isCheckedCarrierMapping =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Carrier Mapping'
      )?.checked || false;
    const isCheckedSubscriptions =
      tabSettingsPracticeDetails?.find(
        (x: any) => x.menuName === 'Subscriptions'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedAccountDetails',
      isCheckedAccountDetails
    );
    this._localStorageService.setData(
      'isCheckedAgreementCC',
      isCheckedAgreementCC
    );
    this._localStorageService.setData(
      'isCheckedPMSConfiguration',
      isCheckedPMSConfiguration
    );
    this._localStorageService.setData(
      'isCheckedProcessorSetting',
      isCheckedProcessorSetting
    );

    this._localStorageService.setData(
      'isCheckedTerminalSetup',
      isCheckedTerminalSetup
    );

    this._localStorageService.setData('isCheckedUser', isCheckedUser);
    this._localStorageService.setData('isCheckedUserRole', isCheckedUserRole);
    this._localStorageService.setData(
      'isCheckedCarrierMaster',
      isCheckedCarrierMaster
    );
    this._localStorageService.setData(
      'isCheckedCarrierPlanMaster',
      isCheckedCarrierPlanMaster
    );
    this._localStorageService.setData(
      'isCheckedCarrierMapping',
      isCheckedCarrierMapping
    );
    this._localStorageService.setData(
      'isCheckedSubscriptions',
      isCheckedSubscriptions
    );
    this._localStorageService.setData(
      'isCheckedPaymentMethodOnFile',
      isCheckedPaymentMethodOnFile
    );
    this._localStorageService.setData(
      'isCheckedScheduledJobs',
      isCheckedScheduledJobs
    );
    const tabSettingsPracticeConfiguration = this.menuListByCustomerSubscription
      .find((x: any) => x.moduleName === 'Practice')
      ?.menus?.[0]?.children?.find(
        (y: any) => y.menuName === 'Configuration'
      )?.children;
    const isCheckedConfigPaymentsAndPaymentPlan =
      tabSettingsPracticeConfiguration?.find(
        (x: any) => x.menuName === 'Payments and Payment Plan'
      )?.checked || false;
    const isCheckedConfigARAutomation =
      tabSettingsPracticeConfiguration?.find(
        (x: any) => x.menuName === 'A/R Automation'
      )?.checked || false;
    const isCheckedConfigPractice =
      tabSettingsPracticeConfiguration?.find(
        (x: any) => x.menuName === 'Practice'
      )?.checked || false;
    const isCheckedConfigPracticeAnalytics =
      tabSettingsPracticeConfiguration?.find(
        (x: any) => x.menuName === 'Practice Analytics'
      )?.checked || false;
    this._localStorageService.setData(
      'isCheckedConfigPaymentsAndPaymentPlan',
      isCheckedConfigPaymentsAndPaymentPlan
    );
    this._localStorageService.setData(
      'isCheckedConfigARAutomation',
      isCheckedConfigARAutomation
    );
    this._localStorageService.setData(
      'isCheckedConfigPractice',
      isCheckedConfigPractice
    );
    this._localStorageService.setData(
      'isCheckedConfigPracticeAnalytics',
      isCheckedConfigPracticeAnalytics
    );
    const isCheckedTemplatePaymentPlan =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'Payment Plan Templates'
      )?.checked || false;

    this._localStorageService.setData(
      'isCheckedTemplatePaymentPlan',
      isCheckedTemplatePaymentPlan
    );
    const isCheckedTemplateARAutomation =
      tabSettingsTemplates?.find(
        (x: any) => x.menuName === 'A/R Automation Templates'
      )?.checked || false;

    this._localStorageService.setData(
      'isCheckedTemplateARAutomation',
      isCheckedTemplateARAutomation
    );

    this.dialog.closeAll();
    //window.location.reload(true);
  }
}
